(function ( $ ) {
    var imageEffects = {};
    
    imageEffects.bigImageWidth = function() {
        if( $('.js-image-single').length ) {
            var containerWidth = $('.js-image-single .container').width();
            var bodyWidth = $('body').width();

            var paddingSpace = (bodyWidth - containerWidth) / 2;

            if($('.js-image-single').hasClass('is-right')) {
                $('.js-image-single .big-image').css('padding-left', paddingSpace);
            }
            else {
                $('.js-image-single .big-image').css('padding-right', paddingSpace);
            }     
        }
    };

    imageEffects.bigImageWidth();

    $( window ).resize( function () {
        imageEffects.bigImageWidth();
    });


})( jQuery );
